import {
  SmartReportComponentTypesEnum,
  SmartReportLayoutIdsEnum,
} from '@/admins/SmartReports/types';

import { SmartReportEntityTypeEnum } from '@/types/GraphqlSchema';

export const SLOT = 'SLOT';

export type LayoutDefinition<
  ComponentProps = unknown,
  ComponentViewProps = unknown,
  ComponentThumbnailProps = unknown,
> = {
  id: SmartReportLayoutIdsEnum;
  title: string;
  description: string;
  Component: React.ComponentType<ComponentProps>;
  ComponentView: React.ComponentType<ComponentViewProps>;
  ComponentThumbnail: React.ComponentType<ComponentThumbnailProps>;
  elementTypes: SmartReportComponentTypesEnum[];
  reportTypes: SmartReportEntityTypeEnum[];
};
